<div id="mode-of-service" class="mos">
    <div>
        <div class="header border-bottom spac-btw">
            <div class="flex">
                <div (click)="closeModal('BACK')" class="float-left closeicon pointer">
                    <img src="./assets/icons/arrow.svg" />
                </div>
                <div class="font-primary-title bold">
                    {{ "title_book_appt" | translate : "LABELS" }}
                </div>
            </div>
            <div (click)="closeModal('CLOSE')" class="float-right closeicon pointer">
                <img src="./assets/icons/close_black.svg" />
            </div>
        </div>

        <div class="modal-pkg-content cards">
            <div class="modal-container">
                <div class="book-appointment-container">

                    <div class="section">
                        <label class="section-label">{{'mode_of_service_ordering_for' | translate}}</label>
                        <div class="patient-info">
                            <!-- <img [src]="visitOptions?.patient?.imageurl || 'assets/icons/user-placeholder.svg'"
                                alt="User" class="patient-img" /> -->
                            <div class="image">
                                <app-person-avatar [url]="visitOptions?.patient?.imageurl"></app-person-avatar>
                            </div>
                            <div class="patient-details">
                                <h3>{{ visitOptions?.patient?.personname }}</h3>
                                <p>{{ visitOptions?.patient?.uhid }}, {{ visitOptions?.patient?.relationshiptype }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="section" *ngIf="appointmentLocationOptions?.length">
                        <label class="section-label">{{ 'mode_of_service_label' | translate }}</label>
                        <div class="radio-group">
                            <ng-container *ngFor="let item of appointmentLocationOptions">
                              <label class="radio-option" *ngIf="!item.disable" [class.active]="selectedAppointmentType === item.value">
                                <input type="radio" name="mode" [value]="item.value"
                                    [(ngModel)]="selectedAppointmentType" (change)="handleRadioChange(item)" />
                                <img *ngIf="item?.value === 'CLINIC'" src="assets/icons/clinic.svg" alt="Clinic" />
                                <img *ngIf="item?.value === 'HOMECARE'" src="assets/icons/packages/homevideo.svg" alt="Home / Video" />
                                <span>{{ item.label | translate }}</span>
                              </label>
                            </ng-container>
                        </div>
                    </div>

                    <div class="section" *ngIf="visitOptions?.package?.packageDtls?.servicesApplicable?.length as serviceLength">
                        <label class="section-label">{{"mode_of_service_package_selected" | translate : 'LABELS' : null:null: {serviceLength: serviceLength} }}</label>
                        <ng-container *ngIf="visitOptions?.package?.packageDtls?.servicesApplicable[0] as services">
                            <div *ngIf="(services | translate : 'PACKAGEOBJ') as service; else NOCONCEPT">
                                <div class="package-item">
                                    <img *ngIf="service._directiveRef?.imageUrl" class="package-desc-icon" [src]="service._directiveRef.imageUrl" alt="Service" />
                                    <!-- <img *ngIf="!service._directiveRef?.imageUrl" class="package-desc-icon" src="./assets/icon/dashboard/package.svg" alt="Package" /> -->
                                    <div class="package-details">
                                        <h4>{{ service.name | translate : 'LOCALE' : 'name'}}</h4>
                                        <!-- <p>{{ service.testsIncluded || 'Package service included' }}</p> -->
                                    </div>
                                </div>
                            </div>
                            <ng-template #NOCONCEPT>
                                <div class="package-item">
                                    <img class="package-desc-icon" src="./assets/icon/dashboard/package.svg" alt="Package" />
                                    <div class="package-details">
                                        <h4>{{ services.directiveCode + ' - ' + services.conceptCode }}</h4>
                                        <p>{{'mode_of_service_package_details_unavailable' | translate}}</p>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </div>
                </div>

                <div class="info-box">
                    <img src="assets/icons/packages/Info.svg" alt="Info" />
                    <p>{{'mode_of_service_package_info' | translate}}</p>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="btn-container">
                <button class="btn-primary" (click)="bookAppointment()">{{'mode_of_service_continue' | translate}}</button>
            </div>
        </div>
    </div>
</div>